const Component = {
    "图片 url 不存在": "Image url does not exist",
    "暂不支持下载此类型图片": "Downloading this type of image is not currently supported",
  }
  
  export default Component;